export default { 
  'SET_LIGAS_TIMES': function (state, val) {
    state.times = val ? val : []
  },
  'SET_GAMES_TIMES': function (state, val) {
    state.timesGames = val ? val : []
  },

  SET_DESEMPENHO: (state, val) => state.desempenho = val
}